import { Component, Input } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DefaultLayoutDirective } from '../../flex-layout/custom-layout';
import { NgIf } from '@angular/common';
import { DefaultLayoutAlignDirective } from '../../flex-layout/custom-layout-align';
import { DefaultStyleDirective } from '../../flex-layout/style';
import { DefaultFlexDirective } from '../../flex-layout/flex';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'calsoft-blog-layout',
  imports: [DefaultLayoutDirective,NgIf, DefaultLayoutAlignDirective, DefaultStyleDirective, DefaultFlexDirective, MatButton],
  templateUrl: './blog-layout.component.html',
  styleUrl: './blog-layout.component.scss'
})
export class BlogLayoutComponent {

  @Input() data: any;
  @Input() bloglayouttype: any;


  @Input() blog: any;

  @Input() name: any;

  @Input() width: any;

  @Input() heightMobile: any;

  @Input() widthMobile: any;
  public serverPath = environment.commonImageApi + "blog/";
  image: string |any;
  @Input() public pageTitle: any
  aboutData: any;
  loaded: any = false;
  layoutype: any = 0;
  @Input() public homePageBuilder: any;

  height: any;
  blogNameDisplayLineMob = 2;
  blogNameDisplayLine = 2;
  blogOverallHeightMob: any;
  blogOverallHeight: any;

  constructor(
    private router: Router,
    public meta: Meta,
    private titleService: Title,

  ) { }
  list: any = [];
  ngOnInit(): void {
    console.log('Blog Layout Type:', typeof this.bloglayouttype, this.bloglayouttype);


    let type = 'website';

    let value = "en_US"

    let currentURL = window.location.href;

    this.image = this.serverPath + this.blog['content'];

    this.titleService.setTitle(this.blog['title'] );

    // this.meta.addTags([
    //   { name: 'author', content: Constant.siteName },
    //   { name: 'keywords', content: this.blog['metaKeywords'] },
    //   { name: 'description', content: this.blog['metaDescription'] },


    //   { property: 'og:title', content: this.blog['rootTemplate'] },
    //   { property: 'og:url', content:currentURL },
    //   { property: 'og:description', content: this.blog['metaDescription'] },
    //   { property: 'og:image', content : this.image },
    //   { property: 'og:locale', content: value },
    //   { property: 'og:type', content: type },


    //   { name: 'twitter:title', content: this.blog['rootTemplate'] },
    //   { name: 'twitter:description', content: this.blog['metaDescription'] },
    //   { name: 'twitter:image', content: this.image },
    //   { name: 'twitter:card', content: "summary_large_image" },
    // ]);

    
    this.height = this.data['blogImageHeight']
    this.width = this.data['blogImageWidth']
    this.widthMobile = this.data['blogImageWidthMob']
    this.heightMobile = this.data['blogImageHeightMob'];
    this.blogNameDisplayLine = this.data['blogNameDisplayLine']
    this.blogNameDisplayLineMob = this.data['blogNameDisplayLineMob']
    this.blogOverallHeight = this.data['blogOverallHeight']
    this.blogOverallHeightMob = this.data['blogOverallHeightMob']
  }





  goToBlogData() {

    this.router.navigate([`blog/${this.blog['uuid']}`], { 
      queryParams: { title: this.blog['title'] }, 
      state: { blogData: this.blog } 
    });
    
  }

}
